<template>
    <div class="d-block">
        <Card :bordered="false">
            <div class="d-flex justify-start">
                <div class="d-block pr-xs width-100">
                    <Select v-model="search.status" placeholder="状态...">
                        <Option value="">全部</Option>
                        <Option :value="1">启用</Option>
                        <Option :value="2">禁用</Option>
                    </Select>
                </div>
                <div class="d-block pr-xs width-160">
                    <Input clearable v-model="search.userName" placeholder="姓名/用户名..."/>
                </div>
                <button class="btn btn-icons btn-warning" @click="getAdmin(page)">
                    <img src="static/icon/search-white@16px.png"/>
                </button>
                <span class="d-flex-item"/>
                <div class="d-block">
                    <button class="btn btn-icons btn-success" @click="onChange({}, '', 1)">
                        <img src="static/icon/plus-white@16px.png">
                    </button>
                    <button class="btn btn-icons btn-danger" v-if="false" @click="onDelete({}, '', 0)">
                        <img src="static/icon/delete-white@16px.png">
                    </button>
                </div>
            </div>
        </Card>

        <br/>

        <Card :bordered="false">
            <p slot="title">管理员列表</p>
            <Table :columns="tableColumns" :data="tableData">
                <template slot-scope="{ row, index }" slot="userName">
                    <span>{{ row.userName !== '' ? row.userName : row.deptName }}</span>
                </template>
                <template slot-scope="{ row, index }" slot="status">
                    <span :class="row.status === 1 ? 'c-success' : 'c-error'">{{ row.status === 1 ? '启用' : '禁用' }}</span>
                </template>
                <template slot-scope="{ row, index }" slot="action" v-if="row._index > 0">
                    <button class="btn btn-sm btn-icons btn-primary" @click="onChange(row, index, 2)">
                        <img src="static/icon/editor-white@16px.png"/>
                    </button>
                    <button class="btn btn-sm btn-icons btn-danger" @click="onDelete(row, index, 1)">
                        <img src="static/icon/delete-white@16px.png"/>
                    </button>
                </template>
            </Table>
            <br/>
            <Page show-total :total="total" :current="page" :page-size="count" @on-change="getAdmin"/>
        </Card>

        <Modal width="420" v-model="changeModal.show" :title="changeModal.title + '管理员'" @on-cancel="onCancel">
            <Form :label-width="80" v-if="changeModal.show">
                <FormItem label="姓名">
                    <Input v-model="changeModal.data.userName"/>
                </FormItem>
                <FormItem label="手机号">
                    <Input v-model="changeModal.data.loginName" type="number" :disabled="changeModal.kind === 2 ? true : false"/>
                </FormItem>
                <FormItem label="新密码">
                    <Input type="password" v-model="changeModal.data.password"/>
                </FormItem>
                <FormItem label="状态">
                    <Select v-model="changeModal.data.status">
                        <Option :value="1">启用</Option>
                        <Option :value="2">禁用</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" @click="onCancel">取消</Button>
                <Button type="primary" @click="onConfirm(changeModal.data, changeModal.kind)">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                search: {},

                tableColumns: [
                    {
                        title: '姓名',
                        slot: 'userName',
                    },
                    {
                        title: '手机号',
                        key: 'loginName',
                    },
                    {
                        title: '状态',
                        slot: 'status',
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                        width: 106,
                    }
                ],
                tableData: [],

                total: 0,
                page: 1,
                count: 15,

                changeModal: {},
            }
        },
        async mounted() {
            await this.getAdmin(this.page);
        },
        methods: {
            async getAdmin(page){
                this.page = page;
                let query = '&status=' + (this.search.status || '') + '&userName=' + (this.search.userName || '');
                let res = await this.$api.getHttp('admin/user/list?page=' + this.page + '&pageSize=' + this.count + query);
                console.log('this.getAdmin---------->', res);
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                this.tableData = [] = res.data.data.rows;
                this.total = res.data.data.total;
            },

            async onChange(data, index, kind){
                debugger
                console.log('this.onChange---------->', data, index, kind);
                this.changeModal = {} = {
                    show: true,
                    title: kind === 1 ? '添加' : '编辑',
                    kind: kind,
                    data: kind === 1 ? {
                        logo: '',
                    } : data,
                }
            },

            async onCancel(){
                this.changeModal = {};
                this.getAdmin(this.page);
            },
            async onConfirm(data, kind){
                debugger
                console.log('this.onConfirm---------->', data, kind);
                if (!data.userName || data.userName === ''){
                    return this.$Message.error('姓名不能为空');
                }
                if (!data.loginName || data.loginName === ''){
                    return this.$Message.error('手机号不能为空');
                }
                if (kind === 1){
                    if ((!data.password || data.password === '')){
                        return this.$Message.error('密码不能为空');
                    }
                    if (Number(data.password) === 0){
                        return this.$Message.error('密码不能以0开头');
                    }
                }
                if (!data.status || data.status === ''){
                    return this.$Message.error('状态不能为空');
                }

                let res;
                if (kind === 1){
                    res = await this.$api.postHttp('admin/user/add', data);
                }
                if (kind === 2){
                    res = await this.$api.putHttp('admin/user/edit', data);
                }
                console.log('this.onConfirm---------->', res);
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                this.$Message.success(res.data.msg);
                this.onCancel();
            },
            async onDelete(data, index, kind){
                debugger
                console.log('this.onDelete---------->', data, index, kind);
                let com = await this.$common.confirmModel('是否确认删除');
                if (!com) return;

                let res = await this.$api.deleteHttp('admin/user/delete?id=' + data.id);
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                this.$Message.success(res.data.msg);
                this.getAdmin(this.page);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/setting/index.vue